import ReceiptBlock, { ReceiptBlockProps } from './ReceiptBlock';

export type { ReceiptBlockProps };
export default ReceiptBlock;
